// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Question_wrapper__NnN5p","choices":"Question_choices__SANn5"};